import React, { useState, useEffect } from "react";
import { getNotesData, addData, updateData } from "../../../lib/pagenotes";

export default function PageNotes({ type, studentId, instructorId, pageName }) {
  const [studentGradeList, setStudentGradeList] = useState();
  const [studentNote, setStudentNote] = useState();
  const [instructorNote, setInstructorNote] = useState();
  const [status, setStatus] = useState("");
  const [recId, setRecId] = useState();
  const [show, setShow] = useState(false);

  const handleSubmitStudent = async (e) => {
    e.preventDefault();
    if (status == "Add") {
      console.log("Add");

      await addData({
        page: pageName,
        studentId: studentId,
        studentNote: studentNote,
      });
      setStatus("Update");
    } else {
      await updateData({
        id: recId,
        page: pageName,
        studentNote: studentNote,
      });
    }
    setShow(true);
  };

  const handleSubmitInstructor = async (e) => {
    e.preventDefault();
    if (status == "Add") {
      console.log(" InstructorAdd");

      await addData({
        page: pageName,
        studentId: studentId,
        studentNote: studentNote,
        instructorId: instructorId,
        instructorNote: instructorNote,
      });
      setStatus("Update");
    } else {
      console.log("Instructor Update", instructorNote);
      await updateData({
        id: recId,
        page: pageName,
        studentId: studentId,
        studentNote: studentNote,
        instructorId: instructorId,
        instructorNote: instructorNote,
      });
    }
    setShow(true);
  };

  async function RecordCheck() {
    const sdata = await getNotesData(studentId, instructorId, pageName);
    console.log("RecordCheck", sdata);

    if (sdata.length === 0) {
      setStatus("Add");
    } else {
      setStatus("Update");
      setRecId(sdata[0].id);
      GetNotes();
    }
  }

  async function GetNotes() {
    const sdata = await getNotesData(studentId, instructorId, pageName);
    setStudentNote(sdata[0].studentNote);
    setInstructorNote(sdata[0].instructorNote);
    setRecId(sdata[0].id);
  }

  useEffect(() => {
    RecordCheck();
    setShow(false);
  }, []);

  const messages = () => {
    return (
      <div
        className="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>Data Updated...</strong>{" "}
        {/*You should check in on some of those fields below.*/}
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          onClick={(e) => setShow(false)}
        ></button>
      </div>
    );
  };

  return (
    <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="p-3">
          {show ? messages() : ""}
          <div className="personal-info-head">
            <h4>Student Note</h4>
          </div>
          <div className="pb-0">
            <div className="settings-referral-blk course-instruct-blk  table-responsive ">
              {/* Instructor Users */}
              <form method="post" onSubmit={handleSubmitStudent}>
                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={studentNote}
                      onChange={(e) => setStudentNote(e.target.value)}
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    Student Note Update
                  </button>
                </div>
              </form>
              {/* Instructor List */}
            </div>
          </div>
        </div>
        <div className="p-3">
          <div className="personal-info-head">
            <h4>Counselor&apos;s Note</h4>
          </div>
          <div className="pb-0">
            <div className="settings-referral-blk course-instruct-blk  table-responsive ">
              {/* Instructor Users */}
              <form method="post" onSubmit={handleSubmitInstructor}>
                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={instructorNote}
                      onChange={(e) => setInstructorNote(e.target.value)}
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                {type === "Instructor" ? (
                  <div className="update-profile d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary">
                      Counselor&apos;s Note Update
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </form>
              {/* Instructor List */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
